import { createTheme } from '@mui/material';

const theme = createTheme({
    palette: {
        primary:{
            main:'#e01d20'
        },
        secondary:{
            main:'#1976d2'
        }
    },
  });

  export  default theme;